export function SpGuideBoxHandle () {
  console.log('SpGuideBoxHandle-this', this)
  this.$emit('chooseStore', false)
  // ctx.$emit()
}
